import { render, staticRenderFns } from "./BE.vue?vue&type=template&id=028c610e&"
import script from "./BE.js?vue&type=script&lang=js&"
export * from "./BE.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports